import React, { Component, PropTypes } from 'react'

import {
    vehicleDrivingRadiusOptions,
    vehiclePassengerOptions,
    yesNoOptions,
} from '../utils'

import { RadioInput, Select, TextInput } from '../ui'

export default class TransportationForm extends Component {
    static propTypes = {
        data: PropTypes.object.isRequired,
        errors: PropTypes.object.isRequired,
        options: PropTypes.object.isRequired,
        updateValueAndSendPatchRequest: PropTypes.func.isRequired,
    }

    render() {
        if (! this.props.data) {
            return null
        }

        const errors = this.props.errors

        let vehicleTypeForm = null

        if (this.props.data.own_car === 1) {
            vehicleTypeForm = (
                <div className="grid grid--break-mobile">
                    <div className="grid__span-4">
                        <Select
                            error={ errors.vehicle_type }
                            label="Vehicle Type"
                            name="vehicle_type"
                            options={ this.props.options.vehicleTypeOptions }
                            placeholder="Select vehicle type"
                            updateValue={ this.props.updateValueAndSendPatchRequest }
                            value={ this.props.data.vehicle_type }
                        />
                        <Select
                            error={ errors.vehicle_make }
                            label="Vehicle Make"
                            name="vehicle_make"
                            options={ this.props.options.vehicleMakeOptions }
                            placeholder="Select vehicle make"
                            updateValue={ this.props.updateValueAndSendPatchRequest }
                            value={ this.props.data.vehicle_make }
                        />
                        <TextInput
                            error={ errors.vehicle_year }
                            label="Vehicle Year"
                            name="vehicle_year"
                            placeholder="Year (eg: 2008)"
                            updateValue={ this.props.updateValueAndSendPatchRequest }
                            value={ this.props.data.vehicle_year }
                        />
                    </div>
                    <div className="grid__span-6">
                        <Select
                            error={ errors.vehicle_passenger_number }
                            label={ (
                                'How many additional crew members can you transport in your ' +
                                'vehicle? Do not include yourself.'
                            ) }
                            name="vehicle_passenger_number"
                            options={ vehiclePassengerOptions() }
                            placeholder="Select passengers"
                            updateValue={ this.props.updateValueAndSendPatchRequest }
                            value={ this.props.data.vehicle_passenger_number }
                        />
                        <Select
                            error={ errors.vehicle_local_driving_radius }
                            label="How far are you willing to drive to still work as a local?"
                            name="vehicle_local_driving_radius"
                            options={ vehicleDrivingRadiusOptions() }
                            placeholder="Select radius"
                            updateValue={ this.props.updateValueAndSendPatchRequest }
                            value={ this.props.data.vehicle_local_driving_radius }
                        />
                    </div>
                </div>
            )
        }

        return (
            <div className="form">
                <div className="grid grid--break-mobile">
                    <div className="grid__span-4">
                        <RadioInput
                            error={ errors.valid_driving_license }
                            label="Do you have a valid drivers license?"
                            name="valid_driving_license"
                            options={ yesNoOptions() }
                            updateValue={ this.props.updateValueAndSendPatchRequest }
                            value={ this.props.data.valid_driving_license }
                        />
                    </div>
                </div>
                <div className="grid grid--break-mobile">
                    <div className="grid__span-4">
                        <RadioInput
                            error={ errors.own_car }
                            label="Do you own a vehicle?"
                            name="own_car"
                            options={ yesNoOptions() }
                            updateValue={ this.props.updateValueAndSendPatchRequest }
                            value={ this.props.data.own_car }
                        />
                    </div>
                </div>

                { vehicleTypeForm }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/personal/transportation_form.js